<div class="dx-field">
  <div class="dx-field-label">{{ placeholderLabel | translate }}</div>
  <div class="dx-field-value" style="display: flex; gap: 8px; align-items: center;">
    <dx-select-box style="flex: 1 1 auto;"
                   [items]="placeholderItems"
                   [displayExpr]="placeholderDisplayExpr"
                   [(value)]="selectedPlaceholderItem"
                   [placeholder]="placeholderSelectText | translate"
                   [disabled]="disabled"></dx-select-box>
    <dx-button icon="bi bi-plus"
               stylingMode="contained"
               type="default"
               [text]="'Einfügen' | translate"
               [disabled]="disabled || !selectedPlaceholderItem"
               (onClick)="insertPlaceholder()"></dx-button>
  </div>
</div>

<div class="dx-field">
  <div class="dx-field-label" style="display: flex; align-items: center; gap: 6px;">
    <span>{{ 'Formel' | translate }}</span>
    <i #formulaInfoTarget class="bi bi-info-circle" style="cursor: help;"></i>
    <dx-tooltip [target]="formulaInfoTarget"
                class="toolTip toolTipField"
                position="bottom"
                targetAnchor="bottom"
                showEvent="mouseenter"
                hideEvent="mouseleave">
      <div *dxTemplate="let data of 'content'">
        <div style="max-width: 450px; white-space: pre-line; text-align: left;">{{ tooltipText | translate }}</div>
      </div>
    </dx-tooltip>
  </div>
  <div class="dx-field-value">
    <dx-text-area [value]="formula"
                  [autoResizeEnabled]="true"
                  [minHeight]="80"
                  [disabled]="disabled"
                  (onValueChanged)="onFormulaValueChanged($event.value)"></dx-text-area>
  </div>
</div>

<div class="dx-field" *ngIf="preview">
  <div class="dx-field-label">{{ 'Vorschau' | translate }}</div>
  <div class="dx-field-value">
    <span *ngIf="preview.success" class="np-text-success">= {{ preview.value }}</span>
    <span *ngIf="!preview.success" class="np-text-error">{{ preview.errorMessage }}</span>
  </div>
</div>
